//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import {buffers} from "redux-saga";
import { eventChannel, delay } from "redux-saga";
import { livefeedservice } from "../";
import config from "../../../boot/config";
import misc from "./misc";

const initialState = {
	registeredPoints: [],
	liveChartTimespanMs: 300000,
	errors: [],
	hasError: false
};

//socket
export const socket = { dispatch: () => 1 }; //dispatch placeholder func

function _readSocket() {
	return eventChannel(emitter => {
		socket.dispatch = action => {
			emitter(action);
		};

		// The subscriber must return an unsubscribe function
		return () => {
			socket.dispatch = () => 1;
		};
	}, buffers.expanding(20));
}

/////////
//types
export const types = {
	MAKE_REQUEST: "live/livefeed/MAKE_REQUEST",
	ON_MAKE_REQUEST: "live/livefeed/ON_MAKE_REQUEST",
	ON_MAKE_REQUEST_FAILED: "live/livefeed/ON_MAKE_REQUEST_FAILED",
	REGISTER_POINT: "live/livefeed/REGISTER_POINT",
	DEREGISTER_POINT: "live/livefeed/DEREGISTER_POINT",
	UPDATE_REGISTERED_POINTS: "live/livefeed/UPDATE_REGISTERED_POINTS",
	PURGE_HISTORY: "live/livefeed/PURGE_HISTORY",
	LIVE_DATA_UPDATED: "live/livefeed/LIVE_DATA_UPDATED",
};

function registerPoint(state, action){
	const existing = state.registeredPoints.find(s => s.pointId === action.payload.point.pointId);
	if(!existing){
		return { ...state, registeredPoints: state.registeredPoints.concat({
			pointId: action.payload.point.pointId,
			values: [],
			count: 1,
			currentValue: 0,
			lastUpdate: new Date(0),
		}) };
	}
	return { 
		...state, 
		registeredPoints: state.registeredPoints.map((point) => 
			point === existing ? {...point, count: point.count + 1} : point
		) 
	};
}

function deregisterPoint(state, action){
	const existing = state.registeredPoints.find(s => s.pointId === action.payload.point.pointId);
	if(existing.count > 1){
		return {
			...state,
			 registeredPoints: state.registeredPoints.map((point) => point === existing ? {...point, count: point.count - 1} : point)
			};
	}else{
		return {
			...state,
			registeredPoints: state.registeredPoints.filter(x => x !== existing)
		};
	}
}

function purgeHistory(state, action){
	const registeredPoints = state.registeredPoints;
	
	for (var ii = 0; ii < registeredPoints.length; ii++) {
		var wkRegisteredPoint = registeredPoints[ii];
		if (!wkRegisteredPoint.lastUpdate) {
			return { ...state };
		}
		var oldestAllowed = wkRegisteredPoint.lastUpdate.getTime() - action.payload.liveChartTimespanMs;
		/* Older data is at teh start of the array. 
		* So for efficiency loop throught the array from the start until we find a point that shouldnt be removed.
		* Then remove all points up to the point.
		*/
		var removeCount = 0;
		for (var jj = 0; jj < wkRegisteredPoint.values.length; jj++) {
			var wkValue = wkRegisteredPoint.values[jj];
			if (wkValue.timestamp.getTime() > oldestAllowed) {
				removeCount = jj;
				break;
			}
		}
		wkRegisteredPoint.values.splice(0, removeCount);
	}
	return { ...state };
}

function updateRegisteredPoints(state, action){
	let regPoints = state.registeredPoints;
	regPoints.forEach(x => {
		const exist = action.payload.points.find(s => s.pointId === x.pointId);
		if (exist) {
			//map into
			x = exist;
		}
	});
	return { ...state, registeredPoints: regPoints };
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {

			case types.MAKE_REQUEST:
				return state;
			case types.ON_MAKE_REQUEST:
				return state;
			case types.ON_MAKE_REQUEST_FAILED:
				return {
					...state,
					errors: state.errors.concat(action.payload).slice(-10),
					hasError: true
				};
			case types.REGISTER_POINT:{
				return registerPoint(state, action);
			}
			case types.DEREGISTER_POINT:{
				return deregisterPoint(state, action);
			}
			case types.PURGE_HISTORY: {
				return purgeHistory(state, action);
			}
			case types.UPDATE_REGISTERED_POINTS: {
				return updateRegisteredPoints(state, action);
			}
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.readSocket(), this.makeRequest(), this.handleRawData()]);
	},

	*readSocket() {
		const socketChannel = yield call(_readSocket);
		for (;;) {
			//read the socket
			const datas = yield take(socketChannel);
			if (datas.type && typeof datas.type === "string") {
				//its an action
				yield put(datas);
			}
		}
	},

	*makeRequest() {
		yield takeEvery(types.MAKE_REQUEST, function*({ payload }) {

			const state = yield select(x => x.livefeed);
			//need a list of point group ids and timestamps
			var pointLiveRequests = state.registeredPoints.map(x => {
				return {
					pointId: x.pointId,
					lastUpdate: x.lastUpdate,
					includeHistory: x.includeHistory
				};
			});

			const data = yield call(livefeedservice.GetLive, pointLiveRequests);
			

			if (data instanceof Error) {				
				if (config.enviroment !== "DEV") {
					yield put(actions.genericAction(types.ON_MAKE_REQUEST_FAILED, data));
				} else {
					//dont hammer the console with json
					console.error("live feed make request failed");
				}
			} else {
				yield put(actions.onMakeRequest(data));
			}
		});
	},
	*handleRawData() {
		yield takeEvery(types.ON_MAKE_REQUEST, function*({ payload }) {
			const registeredPoints = yield select(x => x.livefeed.registeredPoints);
			const liveChartTimespanMs = yield select(x => x.livefeed.liveChartTimespanMs);

			//purge data that is too old
			yield put(actions.purgeHistory(liveChartTimespanMs));
			payload.data.forEach(s => {
				var registeredPoint = registeredPoints.find(x => x.pointId === s.pointId);
				if(registeredPoint){
					if (typeof s.history.to === "string") {
						s.history.to = new Date(s.history.to);
					}
					if (registeredPoint.lastUpdate == null || registeredPoint.lastUpdate < s.history.to) {
						registeredPoint.lastUpdate = s.history.to;
					}
					misc.normaliseTimestamps(s.history.values);
					registeredPoint.currentValue = s.currentValue;
					registeredPoint.values = registeredPoint.values.concat(s.history.values);
				}
			});

			//update reg points with new points
			yield put(actions.updateRegisteredPoints(registeredPoints));

			//trigger all the callbacks so listeners know live data is updated.
			yield put(actions.liveDataUpdated());
		});
	}
};

////////
//actions
export const actions = {
	makeRequest() {
		return {
			type: types.MAKE_REQUEST,
			payload: {}
		};
	},
	onMakeRequest(data) {
		return {
			type: types.ON_MAKE_REQUEST,
			payload: { data }
		};
	},
	registerPoint(point) {
		return {
			type: types.REGISTER_POINT,
			payload: { point }
		};
	},
	deregisterPoint(point) {
		return {
			type: types.DEREGISTER_POINT,
			payload: { point }
		};
	},
	updateRegisteredPoints(points) {
		return {
			type: types.UPDATE_REGISTERED_POINTS,
			payload: { points }
		};
	},
	purgeHistory(liveChartTimespanMs) {
		return {
			type: types.PURGE_HISTORY,
			payload: { liveChartTimespanMs }
		};
	},
	liveDataUpdated() {
		return {
			type: types.LIVE_DATA_UPDATED,
			//payload: {  }
		};
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/services/Live/LiveFeed/redux.js